import { createAsyncThunk } from '@reduxjs/toolkit'
import { plansData } from '@assets/mockdata'
import { Plan, UpdatePlanThunkParams } from '@dataTypes/index'

export const fetchAllPlans = createAsyncThunk(
  'plans/fetchAllPlans',
  async () => {
    return plansData
  },
)

export const addPlan = createAsyncThunk('plans/addPlan', async (body: Plan) => {
  return body
})

export const updatePlan = createAsyncThunk(
  'plans/updatePlan',
  async (params: UpdatePlanThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removePlan = createAsyncThunk(
  'plans/removePlan',
  async (index: string) => {
    return index
  },
)
